/**
 * Point d'entrée pour arcate-webapp
 */

import './tokens.css';
import './typography.js';
import './article-toc.js';
import './index.scss';

// Shared component imports (from @hyperio)
import './imports.js';

// Code spécifique à arcate-webapp
import '@hyperio/components/canvas-placeholder/canvas-placeholder.js';
import '@hyperio/components/navbar/stable-dropdown.js';
import '@hyperio/components/debug/design-review.js';
// Coloration syntaxique — chargée À LA DEMANDE, et seulement si la page contient
// du code. highlight.js et ses langages pèsent ~205 Ko à eux seuls, soit la plus
// grosse part d'app.js : en import statique, chaque page les téléchargeait, alors
// que très peu affichent du code. L'import dynamique les sort dans un chunk séparé.
//
// Le test du DOM est sûr : les scripts sont injectés en fin de <body> (ui:body /
// ui:body-full), donc la page est déjà parsée quand ceci s'exécute.
if (document.querySelector('pre code')) {
	import('@hyperio/components/code-highlight/code-highlight.js');
}

// Optional module behaviors activate only when their own HTML is present.
import './optional/tinyform-editor/auto-submit.js';
import './optional/suggest/suggest.js';
import './optional/tinyform/submit.js';
import './optional/tinyform/draft.js';
import './optional/mydata/browse.js';
import './optional/mydata/screens.js';
import './optional/offer-hub/context-file.js';
import './optional/sky-chart/index.js';
import './optional/sky-live/sky-live.js';
import './optional/synastry/synastry.js';
import './optional/theme-studies/theme-studies.js';
import './optional/moon-phase/moon-phase.js';
import './optional/sun-arc/sun-arc.js';
import './optional/city-autocomplete/city-autocomplete.js';
import './optional/local-clock/local-clock.js';
